import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {MoreOptionsModalProps} from '@Modals/more-options-modal/more-options-modal';

export const openMoreOptionsModal = (props: MoreOptionsModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.MORE_OPTIONS_MODAL,
      panelProps: props,
    })
  );
};
